import React from "react";
import { PageHero } from "../components/PageHero";
import { Solutions as SolutionsSection } from "../components/sections/Solutions";
import { ContactCTA } from "../components/sections/ContactCTA";
import { useLang } from "../i18n/LanguageContext";
import { SOLUTIONS } from "../data/content";

export default function Solutions() {
  const { t } = useLang();
  return (
    <>
      <PageHero
        overline={t(SOLUTIONS.overline)}
        title={t(SOLUTIONS.title)}
        subtitle={t(SOLUTIONS.sub)}
      />
      <SolutionsSection hideHeading />
      <ContactCTA />
    </>
  );
}
